import styled from 'styled-components';
import Button from '../button/Button';
export const LocationDetailsContainer = styled.div `
  position: relative;
  overflow: hidden;
`;
export const MainContent = styled.div `
  display: flex;
  flex-direction: column;

  padding: 1.1rem 2.2rem 1.6rem;
`;
export const LocationWrapper = styled.div `
  display: flex;

  margin-bottom: 2.1rem;
`;
export const LocatonIconWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;

  width: 5rem;
  height: 5rem;

  margin-right: 1rem;

  border-radius: ${({ theme }) => theme.borderRadius.highest};

  background-color: ${({ theme }) => theme.colors.interactive.secondary};
`;
export const TextWrapper = styled.div `
  display: flex;
  flex-direction: column;
`;
export const Map = styled.iframe `
  margin-bottom: 2.2rem;

  border-radius: ${({ theme }) => theme.borderRadius.mediumHigh};

  ${({ theme }) => theme.media.laptop `
    height: 20rem;
  `};
`;
export const WorkingHoursHeader = styled.div `
  display: flex;
  align-items: center;
  margin-bottom: 1.4rem;
`;
export const WorkingHoursWrapper = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: end;

  width: 100%;
`;
export const TimeWrapper = styled.div `
  width: 12rem;
  text-align: right;
`;
export const DirectionButton = styled(Button) `
  border-color: ${({ theme }) => theme.colors.interactive.brandColor};
  margin-bottom: 1.6rem;
  ${({ theme }) => theme.media.tablet `
    margin-bottom: 1.6rem;
  `};
`;
export const ContactUsWrapper = styled.div `
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: space-between;

  width: 100%;

  box-shadow: ${({ theme }) => theme.shadows.white_upper};

  padding: 2rem;

  border-top-left-radius: ${({ theme }) => theme.borderRadius.high};
  border-top-right-radius: ${({ theme }) => theme.borderRadius.high};

  ${({ theme }) => theme.media.tablet `
    padding: 2rem 2.6rem;
    gap: 1rem;
  `};
`;
export const CustomButton = styled(Button) `
  display: flex;
  width: 15.1rem;
  padding: 1.4rem 2rem;
  justify-content: center;
  align-items: center;
  gap: 0.8rem;
  border-radius: ${({ theme }) => theme.borderRadius.x2};
`;
export const TimeIconWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;

  width: 5rem;
  height: 5rem;

  margin-right: 1rem;

  border-radius: ${({ theme }) => theme.borderRadius.highest};

  background-color: ${({ theme }) => theme.colors.interactive.secondary};
`;
export const WorkingHoursContainer = styled.div `
  background-color: ${({ theme }) => theme.colors.surface.tertiary};
  border-radius: ${({ theme }) => theme.borderRadius.x4};
  padding: 1.6rem;
  margin-bottom: ${({ isVisible }) => (isVisible ? '2.5rem' : '0')};
  gap: 0.8rem;
`;
//# sourceMappingURL=styles.js.map